// src/pages/OrderPage.jsx
import React from "react";
import Cart from "../components/Cart";

export default function OrderPage() {
  return (
    <div className="order-page">
      <Cart />
    </div>
  );
}
